// TODO: Change this, this is provisional
const NotFound = () => <h1 style={{ textAlign: "center" }}>404</h1>;

export default NotFound;
